var React = require('react');

function IconOracle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.5 0C4.25329 0 0 4.25329 0 9.5C0 14.7467 4.25329 19 9.5 19H20.5C25.7467 19 30 14.7467 30 9.5C30 4.25329 25.7467 0 20.5 0H9.5ZM9.5 3C5.91015 3 3 5.91015 3 9.5C3 13.0899 5.91015 16 9.5 16H20.5C24.0899 16 27 13.0899 27 9.5C27 5.91015 24.0899 3 20.5 3H9.5Z","fill":"black"}));
}

IconOracle.defaultProps = {"width":"30","height":"19","viewBox":"0 0 30 19","fill":"none"};

module.exports = IconOracle;

IconOracle.default = IconOracle;
